import { Stack, Typography } from "@mui/material";
import { LocalizationProvider, MultiSectionDigitalClock } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useFormikContext } from "formik";
import { useAppSelector } from "@/hooks";
import { Branch } from "@/types/branch";

export type IAdminScheduleTimeForm = {
  scheduleTime: Date | null;
};

const AdminScheduleTime = () => {
  const formik = useFormikContext<IAdminScheduleTimeForm>();
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);
  const organization = useAppSelector((store) => store.organizations[organizationId ?? ""]);
  const branchId = useAppSelector((store) => store.order.branch?.id);

  const now = new Date();

  const orgBranch = organization?.branches?.find((b: Branch) => b.id === branchId);

  const currentKeyDay = new Date().toLocaleDateString("en-US", { weekday: "short" }).toLowerCase();

  const openHours = orgBranch?.schedule?.[currentKeyDay]?.openHours?.[0];
  const start = openHours?.start;
  const end = openHours?.end;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6" gutterBottom>
          Selecciona un horario
        </Typography>

        <Stack spacing={3} alignItems="center">
          <MultiSectionDigitalClock
            value={formik.values.scheduleTime}
            onChange={(value) => {
              formik.setFieldValue("scheduleTime", value);
            }}
            minTime={start ? new Date(`${now.toISOString().split("T")[0]}T${start}`) : undefined}
            maxTime={end ? new Date(`${now.toISOString().split("T")[0]}T${end}`) : undefined}
            sx={{
              justifyContent: "center",
            }}
          />
        </Stack>
      </Stack>
    </LocalizationProvider>
  );
};

export default AdminScheduleTime;
